export const useConvexSiteUrl = () => {
    const convexSiteUrl = process.env.REACT_APP_CONVEX_URL?.replace(
        /\.cloud$/,
        ".site"
    );
    
    return convexSiteUrl;
};